// Port of api/fuel/app/classes/controller/api/monty/select/index.php
import DB from 'offline/db'
export default function(params) {
	var key = params.key
	var exclude = params.exclude || []
	var type = params.type || 'results'
	if (!key) return Promise.resolve({ session: { offline: true }, data: { index: [] } })
	var rows = DB.query('SELECT search_index, search_games FROM search WHERE search_key = ?', [key])
	if (!rows.length) return Promise.resolve({ session: { offline: true }, data: { index: [] } })
	var index = rows[0].search_index ? rows[0].search_index.split(',').map(Number) : []
	var games = rows[0].search_games ? rows[0].search_games.split(',').map(Number) : []
	if (exclude.length) {
		index = index.filter(function(id) { return exclude.indexOf(id) === -1 })
		games = games.filter(function(id) { return exclude.indexOf(id) === -1 })
	}
	var result = { index: index }
	if (type === 'games' || type === 'both') result.games = games
	return Promise.resolve({ session: { offline: true }, data: result })
}
